import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { LeadStatusRequest } from './requests/lead-status.request';
import { LeadStatusResponse } from './responses/lead-status.response';
import IService from '@types_main/iservice';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';

export class LeadStatusService extends BaseService implements IService<LeadStatusResponse> {
    protected get resourceName(): string {
        return 'crm/lead-statuses';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<LeadStatusResponse>>> {
        return await this.get<PagedResponse<LeadStatusResponse>>('paginated' + (filter ?? ''), params);
    }

    public async getList(): Promise<AxiosResponse<{ data: LeadStatusResponse[] }>> {
        return await this.get('');
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: LeadStatusResponse }>> {
        return await this.get(id);
    }

    public async create(body: LeadStatusRequest): Promise<AxiosResponse<{ data: LeadStatusResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: LeadStatusRequest): Promise<AxiosResponse<{ data: LeadStatusResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
